$.routes.addFilter('zipCode', function(seg) {
	return /^\d{5}$/.test(seg);
});

$.routes.map({
	'$any:once': [
		'chain',
		'common',
		'navigation',
		'hideFingerprintCta'
	],
	'$any': [
		'dropdowns',
		'equalHeights'
	],
	'$any:unload': [
		'dropdowns:unload',
		'hideFingerprintCta:unload'
	],
	'$root': 'home',
	'$root:unload': 'identoMap:unloadSearch',
	'faqs': {
		'$root': 'accordion',
		'$root:unload': 'accordion:unload'
	},
	'locations': {
		'$root': 'identoMap',
		'$root:unload': [
			'identoMap:unload',
			'identoMap:unloadSearch',
			'identoMap:unloadMap',
			'identoMap:unloadLocations'
		],
		'$slug': 'hideFingerprintCta',
		'$slug:unload': 'hideFingerprintCta:unload'
	},
	'services': {
		'$root': 'services',
		'$slug': {
			'$any': [
				'accordion',
				'services',
				'hideFingerprintCta'
			]
		},
		'$any:unload': [
			'accordion:unload',
			'hideFingerprintCta:unload',
			'identoMap:unloadSearch',
			'services:unload'
		]
	},
	'landingPage': {
		'$root': 'home',
		'$slug': {
			'$any': [
				'hideFingerprintCta'
			]
		},
		'$any:unload': [
			'hideFingerprintCta:unload'
		]
	},
	'solutions': 'solutions',
	'solutions:unload': 'solutions:unload'
});

$.ready('routes:run');
